import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { primary, lightBlue } from '../../assets/colors.js';
import { PlayfairDisplay, Montserrat } from '../../assets/fonts.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var TitleFrame = styled.h4(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-top: 8px;\n  padding-bottom: 8px;\n  color: ", ";\n  font-weight: bold;\n  font-family: ", ";\n  font-size: 24px;\n  line-height: 1.46;\n  letter-spacing: -0.2px;\n"])), primary, PlayfairDisplay);
var LinkFrame = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 12px;\n  text-align: left;\n  line-height: 2;\n"])), function (props) {
  return props.lightBlue;
}, Montserrat);
var ResourceCardBox = styled.div.attrs({
  className: "resource-card"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1;\n  padding: 0 20px;\n  margin: 10px 0;\n  @media (max-width: 767px) {\n    width: 100%;\n    flex: none;\n  }\n"])));
var ResourceCardContent = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  ", ";\n\n  @media (max-width: 767px) {\n    width: 100%;\n    padding: 15px 30px;\n    flex: none;\n  }\n"])), function (_ref) {
  var vertical = _ref.vertical;
  return vertical ? "row" : "column";
}, function (_ref2) {
  var vertical = _ref2.vertical;
  return !vertical && "margin: 0 auto";
});
var ResourcesCardDefinition = function ResourcesCardDefinition(_ref3) {
  var _ref3$resource = _ref3.resource;
    _ref3$resource.id;
    var label = _ref3$resource.label,
    items = _ref3$resource.items;
    _ref3$resource.user;
    var icon = _ref3$resource.icon,
    vertical = _ref3.vertical;
  return /*#__PURE__*/React__default.createElement(ResourceCardBox, null, /*#__PURE__*/React__default.createElement(ResourceCardContent, {
    vertical: vertical
  }, /*#__PURE__*/React__default.createElement("div", null, icon && icon()), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(TitleFrame, null, label), items && items.map(function (item) {
    return typeof item.comp === "function" ? item.comp() : /*#__PURE__*/React__default.createElement("div", {
      key: item.label
    }, /*#__PURE__*/React__default.createElement(LinkFrame, {
      pgaBlue: primary,
      lightBlue: lightBlue,
      href: item.url,
      target: item.target,
      rel: "noopener noreferrer"
    }, item.label));
  }))));
};
ResourcesCardDefinition.displayName = "ResourcesCard";
ResourcesCardDefinition.propTypes = {
  resource: PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      type: PropTypes.string,
      url: PropTypes.url,
      target: PropTypes.target
    })).isRequired
  }).isRequired,
  vertical: PropTypes.bool
};

export { ResourcesCardDefinition as default };
